import React from "react";
// import TestDocx from "./TestDocx/TestDocx";
// import TestDocx2 from "./TestDocx/TextDocx2";

const TestArea = () => {
  // return (
  //   <>
  //     <TestDocx />
  //     <TestDocx2 />
  //   </>
  // );
  return null;
};
export default TestArea;
